class Client {
	constructor(instance) {
		this.axios = instance;
	}
	async getList(params) {
		try {
			const response = await this.axios.get(`/client/list`, {params})
	
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	async getInfo(id) {
		try {
			const response = await this.axios.get(`/client/${id}?renderFormat=true`)
	
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	async add(info) {
		try {
			const response = await this.axios.put(`/client`, info)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	async edit(id, body) {
		try {
			const response = await this.axios.patch(`/client/${id}`, body)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	async deleteClient(id) {
		try {
			const response = await this.axios.delete(`/client/${id}`)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 담당자 목록
	async getManager(id, type) {
		try {
			const response = await this.axios.get(`/client/manager/${id}/${type}`)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 담당자 추가
	async addManager(id, type, body) {
		try {
			const response = await this.axios.post(`/client/manager/${id}/${type}`, body)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 담당자 수정
	async editManager(id, body) {
		try {
			const response = await this.axios.put(`/client/manager/${id}`, body)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 담당자 삭제
	async deleteManager(id) {
		try {
			const response = await this.axios.delete(`/client/manager/${id}`)
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 시료 리스트 조회
	async getClientSpecimen(id, keyword) {
		try {
			const res = await this.axios.get(`/client/sample/${id}?keyword=${keyword}`);
			return res.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 시료 가져오기(info)
	async getClientSpecimenInfo(clientId, sampleId) {
		try {
			const response = await this.axios.get(`/client/sample/${clientId}/${sampleId}`);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 내 시료 등록
	async addClientSpecimen(clientId, body) {
		try {
			const response = await this.axios.post(`/client/sample/${clientId}`, body);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 시료 수정
	async editClientSpecimen(clientId, sampleId, body) {
		try {
			const response = await this.axios.patch(`/client/sample/${clientId}/${sampleId}`, body);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//고객사 시료 삭제
	async deleteClientSpecimen(clientId, sampleId) {
		try {
			const response = await this.axios.delete(`/client/sample/${clientId}/${sampleId}`);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//법정 기준 가져오기(목록)
	async getLegalStandardList() {
		try {
			const response = await this.axios.get(`/client/sample/standard`);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//법정 기준 가져오기(상세)
	async getLegalStandardDetail(standardId) {
		try {
			const response = await this.axios.get(`/client/sample/standard/${standardId}`);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
	//시험일지 목록 - 업무 분류별 시험항목 가져오기
	async getClientTestCategory(type) {
		try {
			const response = await this.axios.get(`/admin/report/list?category=${type}`);
			return response.data;
		} catch(e) {
			return e.response
		}
	}
}

export default Client;